
import React from "react";
import { Bell, Settings } from "lucide-react";
import Aays from "../assets/img/AaysLogo.png";
import HeaderContent from "./HeaderContent";

const Header = () => {


  return (
    <header className="sticky top-0 z-50 w-full h-[56px] bg-white border-b border-gray-200 flex items-center justify-between px-6">

      <HeaderContent />

    </header>
  );
};

export default Header;